export const ENVIRONMENT = {
    ENVIRONMENT: 'PRO'
}
